import React, { Component } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import ApiAssets from "../../utils/api.assets";
import Loading from "../../components/Loading";

class LeaveMessageInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      ownerMessage: {
        message: props.ownerMessage
      },
      isOpen: false
    };

    this.save = this.save.bind(this);
    this.handleInputLeaveMessage = this.handleInputLeaveMessage.bind(this);
  }

  save() {
    const assetline = this.props.assetline;

    ApiAssets.putMessage(assetline, this.state.ownerMessage.message).then(
      response => {
        this.props.toggleLeaveMessageModal();
        this.props.changeAssetLine(assetline);
      }
    );
  }

  handleInputLeaveMessage(event) {
    const target = event.target;
    const value = target.value;

    if (value !== "") {
      this.setState({ ownerMessage: { message: value } });
    } else {
      this.setState({ ownerMessage: { message: value } })
    }
  }

  render() {
    return (
      <Modal className="modal-md" isOpen={this.props.openModalMessageOwner}>
        <ModalBody>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                {/* <label>Create your own message: </label> */}
                <label>Leave your message to the universe! </label>
                <input
                  className="form-control"
                  onInput={this.handleInputLeaveMessage}
                  value={this.state.ownerMessage.message}
                />{" "}
                <Button
                  className="btn-back"
                  onClick={this.props.toggleLeaveMessageModal}
                >
                  Back
              </Button>
                <Button className="btn-save" onClick={this.save}>
                  Save
              </Button>
              </div>
            </div>
          </div>
        </ModalBody>
        <Loading active={this.state.loading} />
      </Modal>
    );
  }
}

export default LeaveMessageInput;



// WEBPACK FOOTER //
// ./src/containers/AssetPage/leave-message-modal.js